export const getParamFromPath = (
  path: string,
  param: string
): string | undefined => {
  const pathParts = path.split('/')
  const paramIndex = pathParts.indexOf(param)

  return paramIndex !== -1 ? pathParts[paramIndex + 1] : undefined
}
